import { Button } from 'react-bootstrap';
import React, { useEffect } from 'react';

import { useSelector } from 'react-redux';
import selectors from '../../../../selectors/selectors.js';
import ComposerModal from './ComposerModal.js';
import { sendChatComposerFacebookMessenger } from '../../redux/leadModalActions.js';
import { action } from '../../../../lib/actionHelpers.js';
import PillSelect from '../../../../components/PillSelect.js';
import TextComposerTemplateSelect from './textComposer/TextComposerTemplateSelect.js';

const FacebookMessengerComposer = () => {
  const chatHistory = useSelector(selectors.chatMessages);
  const composerPhone = useSelector((state) => state.leadModal.composerPhone);
  const registrations = (useSelector(selectors.serviceProviderPlatformRegistrations) || []).filter((n) => n.platform_code === 'facebookmessenger');
  const platformRegistrationId = composerPhone.platformRegistrationId;
  const platformRegistration = registrations.find((n) => n.id === platformRegistrationId);

  const message = chatHistory.find((n) => (n.platform || {}).code === 'facebookmessenger');
  const disableSend = !composerPhone.message;
  const placeholder = !message ? `No Facebook Messenger message to reply to.` : 'Type your message here';

  const fromOptions = registrations.map((n) => ({ id: n.id, label: n.name }));

  useEffect(() => {
    if (!platformRegistration) {
      action('leadModalPatchComposerPhone', {
        platformRegistrationId: registrations[0].id,
      });
    }
  }, [platformRegistration]);

  const handleFromChange = (option) => {
    action('leadModalPatchComposerPhone', { platformRegistrationId: option.id });
  };

  const handleMessageChange = (e) => {
    action('leadModalPatchComposerPhone', {
      message: e.target.value,
    });
  };

  return (
    <ComposerModal className={'facebook-messenger-composer'} title={'Send Facebook Messenger Message'} focusElement={'.facebook-messenger-composer-message'}>
      <div className={'composer-row'}>
        <div className={'label'}>From</div>
        <div className={'content'}>
          <PillSelect options={fromOptions} value={composerPhone.platformRegistrationId} onChange={handleFromChange} />
        </div>
        <div className={`right-options`}>
          <div className={'right-option'}>
            <TextComposerTemplateSelect />
          </div>
        </div>
      </div>
      <div className={'composer-content'}>
        <textarea disabled={!message} name="message" placeholder={placeholder} value={composerPhone.message} onChange={handleMessageChange} className={`facebook-messenger-composer-message`} spellCheck={true} />
      </div>
      <div className={'composer-footer'}>
        <div className={'left'}>
          <Button variant={'primary'} disabled={disableSend} onClick={() => sendChatComposerFacebookMessenger()}>
            <span>Send</span>
          </Button>
        </div>
      </div>
    </ComposerModal>
  );
};

export default FacebookMessengerComposer;
